import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, MainHeading } from '../../../ui/Elements'
import { useTranslation } from 'react-i18next'
import { Video } from '../../../ui/AllImages'

const WhyChoose = () => {
    const { t } = useTranslation()
    const WhatsApp = () => {
        const phoneNumber = '+966535316584';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    return (
        <WhyChooseWrapper className='container-fluid common-space whyChooseFluid'>
            <Container>
                <Box className='whyChooseWrapper' onClick={WhatsApp} role="button" tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') WhatsApp(); }}>
                    <video autoPlay muted loop>
                        <source src={Video} type="video/webm" />
                    </video>
                    <Box className='d-flex flex-column align-items-center justify-content-center text-center my-3 main-heading'>
                        <MainHeading color="var(--white)" className='py-2 whyChooseHeading'>{t('Whychoose')} <span> {t('Sahab-al-Alam')}</span></MainHeading>
                    </Box>
                    <Row className='whyChooseRow'>
                        <Col lg={3} md={6} sm={12}>
                            <Box className='whyChooseTitle'>
                            {t('Trip')}
                            </Box>
                            <Box className='whyChooseText'>
                                +10,000
                            </Box>
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <Box className='whyChooseTitle'>
                            {t('Destination')}
                            </Box>
                            <Box className='whyChooseText'>
                                +40
                            </Box>
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <Box className='whyChooseTitle'>
                            {t('YearsExperience')}
                            </Box>
                            <Box className='whyChooseText'>
                                +5
                            </Box>
                        </Col>
                        <Col lg={3} md={6} sm={12}>
                            <Box className='whyChooseTitle'>
                            {t('SatisfiedCustomer')}
                            </Box>
                            <Box className='whyChooseText'>
                                +1,000
                            </Box>
                        </Col>
                    </Row>
                </Box>
                
                
            </Container>
        </WhyChooseWrapper>

    )
}
const WhyChooseWrapper = styled.section`
    .whyChooseWrapper{
        position: relative;
        overflow: hidden;
        cursor: pointer;
        video {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            min-width: 100%;
            min-height: 100%;
            z-index: 1;
        }
    }
    
`

export default WhyChoose
